"use strict";
// tslint:disable
/**
 * Laravel WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileFlagsToJSON = exports.ProfileFlagsFromJSONTyped = exports.ProfileFlagsFromJSON = void 0;
var runtime_1 = require("../runtime");
function ProfileFlagsFromJSON(json) {
    return ProfileFlagsFromJSONTyped(json, false);
}
exports.ProfileFlagsFromJSON = ProfileFlagsFromJSON;
function ProfileFlagsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'allowedReservationTypes': !runtime_1.exists(json, 'allowed_reservation_types') ? undefined : json['allowed_reservation_types'],
        'allowedTradeTypesWhenSelling': !runtime_1.exists(json, 'allowed_trade_types_when_selling') ? undefined : json['allowed_trade_types_when_selling'],
        'canCreateOffer': !runtime_1.exists(json, 'can_create_offer') ? undefined : json['can_create_offer'],
        'canPurchasePoints': !runtime_1.exists(json, 'can_purchase_points') ? undefined : json['can_purchase_points'],
        'canReserveOffer': !runtime_1.exists(json, 'can_reserve_offer') ? undefined : json['can_reserve_offer'],
        'eligibleReservationTypes': !runtime_1.exists(json, 'eligible_reservation_types') ? undefined : json['eligible_reservation_types'],
        'eligibleTradeTypesWhenSelling': !runtime_1.exists(json, 'eligible_trade_types_when_selling') ? undefined : json['eligible_trade_types_when_selling'],
        'isEmailVerified': !runtime_1.exists(json, 'is_email_verified') ? undefined : json['is_email_verified'],
    };
}
exports.ProfileFlagsFromJSONTyped = ProfileFlagsFromJSONTyped;
function ProfileFlagsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'allowed_reservation_types': value.allowedReservationTypes,
        'allowed_trade_types_when_selling': value.allowedTradeTypesWhenSelling,
        'can_create_offer': value.canCreateOffer,
        'can_purchase_points': value.canPurchasePoints,
        'can_reserve_offer': value.canReserveOffer,
        'eligible_reservation_types': value.eligibleReservationTypes,
        'eligible_trade_types_when_selling': value.eligibleTradeTypesWhenSelling,
        'is_email_verified': value.isEmailVerified,
    };
}
exports.ProfileFlagsToJSON = ProfileFlagsToJSON;
